export default "__VITE_ASSET__7987637d__"